if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}


// Popup in Ingredients section starts
function openPopup(el) {
  $(".popup").hide();
  $("#" + el).fadeIn(200);
  // if($(".features_slider").hasClass('slick-initialized')) {
  //   $(".features_slider").slick("refresh");
  // }
}

function closePopup() {
    $(".popup").fadeOut(300);
}

// Popup in Ingredients section ends

//popup slider starts
$(".popup_slider").not('.slick-initialized').slick({
    dots: false,
    autoplay: false,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    lazyLoad: "progressive",
    autoplaySpeed: 2000,
    centerMode: true,
    prevArrow:
            "<img class='slick-prev img-responsive' src='//cdn.shopify.com/s/files/1/0676/5926/8338/files/Group_145248.svg'>",
        nextArrow:
            "<img class='next slick-next img-responsive' src='//cdn.shopify.com/s/files/1/0676/5926/8338/files/Group_145247.svg'>",
    
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
            },
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
            },
        },
        {
            breakpoint: 1600,
            settings: {
              arrows: true
            },
        },
    ],
});

// Redirecting the ingredient card to its info inside popup slider starts
$("[data-slide]").click(function (e) {
    e.preventDefault();
    var slideno = $(this).data("slide");
    $(".popup_slider").slick("slickGoTo", slideno - 1);
});
// Redirecting the ingredient card to its info inside popup slider ends

// scroll section starts
$(".scrollTo").click(function () {
    $("html, body").animate(
        {
            scrollTop: $($(this).attr("href")).offset().top,
        },
        500
    );
    return false;
});

// scroll section ends

//popup slider ends